type Project = {
  name: string;
  badge: string;
  desc: string;
  url: string;
  accent: string;
};

const projects: Project[] = [
  {
    name: "ERPlisity",
    badge: "B2B SaaS",
    desc: "Real-time PO visibility and supplier collaboration for manufacturers. Email-native, ERP-agnostic — no portal logins required.",
    url: "https://erplisity.com",
    accent: "var(--yellow)",
  },
  {
    name: "Rubyn AI",
    badge: "Dev tools",
    desc: "An AI code assistant built specifically for Ruby on Rails. Refactors fat controllers, generates idiomatic RSpec, catches N+1 queries.",
    url: "https://rubyn.ai",
    accent: "var(--red)",
  },
  {
    name: "Hivemind",
    badge: "Open source",
    desc: "An open-source framework for AI agent teams that actually work together — orchestration, coordination, and tooling without the proprietary lock-in.",
    url: "https://hivementality.ai",
    accent: "var(--orange)",
  },
  {
    name: "Ampwrecked",
    badge: "Consumer",
    desc: "A music discovery platform for post-hardcore, emo, and punk fans — with bands, events, playlists, and news in one place.",
    url: "https://ampwrecked.com",
    accent: "var(--orange)",
  },
  {
    name: "Sportwire",
    badge: "Web app",
    desc: "Turn any phone, tablet, or screen into a professional live sports ticker. Real-time scores, no downloads.",
    url: "https://sportwire.io",
    accent: "var(--sky)",
  },
  {
    name: "Subtle & Spirited",
    badge: "Brand",
    desc: "Premium hand-crafted keto-friendly mixers from Liberty Hill, TX. No junk, no guilt, all vibe.",
    url: "https://subtleandspirited.com",
    accent: "var(--yellow-bright)",
  },
  {
    name: "C.O.W TX",
    badge: "Brand",
    desc: "Claire's Original Wares — small-batch goods out of Texas, built with the same hands-on attention we bring to every project.",
    url: "https://cowtx.com",
    accent: "var(--red)",
  },
  {
    name: "Poly Grid",
    badge: "Dev tools",
    desc: "One-click AI agent workspaces for macOS — save your whole rig (agents, layout, working directories) and load it back in a click.",
    url: "https://poly-grid.com",
    accent: "var(--sky)",
  },
];

const niceUrl = (u: string) => u.replace(/^https?:\/\//, "").replace(/\/$/, "");

export function Portfolio() {
  return (
    <section className="section portfolio" id="work">
      <div className="container">
        <div className="portfolio-head">
          <div>
            <span className="eyebrow">Things we&rsquo;ve built</span>
            <h2 className="section-title">Receipts, not slide decks.</h2>
            <p className="section-sub">
              We&rsquo;ve shipped real systems for SaaS founders, dev tools, and
              consumer brands. Same playbook works for contractors, trades, and
              shops drowning in paperwork &mdash; the problems just have different
              names.
            </p>
          </div>
        </div>

        <div className="portfolio-grid">
          {projects.map((p) => (
            <a
              key={p.name}
              className="project"
              href={p.url}
              target="_blank"
              rel="noreferrer noopener"
              style={{ ["--accent" as never]: p.accent }}
            >
              <div className="project-head">
                <span className="project-badge">{p.badge}</span>
                <span className="project-link">live ↗</span>
              </div>
              <h3 className="project-name">{p.name}</h3>
              <p className="project-desc">{p.desc}</p>
              <div className="project-foot">
                <span className="project-url">{niceUrl(p.url)}</span>
                <span className="project-arrow" aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <path d="M5 12h14M13 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
